// Exported from here to be easily accessible from other packages
export const ACCOUNT_QUERY_KEY = 'ACCOUNT_QUERY_KEY';
